import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import ManagePrograms from 'src/components/Elements/ManagePrograms';

const ProgramManagementModal = () => (
  <ModalBase
    name={MODALS.managePrograms}
    size={MODALS_SIZE.small}>
    <ManagePrograms />
  </ModalBase>
);

export default ProgramManagementModal;
